// =============================================================================
// PlayerMasthead — the player side's one header (S100 Build 2, extracted S103)
// =============================================================================
// Deliberately NOT the Front Office's and not the FluxEngine board chrome.
// Lifted verbatim from MyProfile.jsx when /my-outreach/:campaignId became the
// second player page, so both pages share one masthead instead of two copies
// that drift. One brand line, the player's full name, one sign-out.
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase.js';

export default function PlayerMasthead({ playerName = '' }) {
  const navigate = useNavigate();

  async function signOut() {
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  }

  return (
    <header className="bg-hunter-deep">
      <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between gap-4">
        <div>
          <div className="font-display font-black text-white text-xl leading-none">Coach Cole Football</div>
          <div className="text-mid-green text-sm font-bold mt-1">{playerName || 'Player Portal'}</div>
        </div>
        <button type="button" onClick={signOut} className="text-sm text-white/80 hover:text-white underline">
          Sign out
        </button>
      </div>
    </header>
  );
}
